export { default } from "./AddToolTip";
